<template>
    <div>
        <h3 class="mb-3">{{category.full_name}}</h3>
        <div v-if="$store.state.companyAdmin" class="mb-6">
            <div>
                <vs-button class="mt-3" @click="addCategoryPromptActive = true">Dodaj podkategorijo</vs-button>
                <vs-button class="mt-3 ml-3" @click="editCategoryPromptActive = true">Uredi kategorijo</vs-button>
                <vs-button class="mt-3 ml-3" @click="removeCategory">Izbriši kategorijo</vs-button>
                <vs-button class="mt-3 ml-3" @click="addFoodPromptActive = true">Dodaj jed</vs-button>
            </div>

            <div class="vx-row">
                <div class="vx-col w-full">
                    <options-table :base-u-r-l="'/api/management/v1/categories/category/' + categoryId"/>
                </div>
                <div class="vx-col xl:w-5/12 lg:w-1/2 w-full">
                    <additions-table :base-u-r-l="'/api/management/v1/categories/category/' + categoryId"/>
                </div>
            </div>
        </div>

        <template>
            <div class="items-grid-view vx-row match-height">
                <div class="vx-col xl:w-1/4 lg:w-1/2 sm:w-1/2 w-full" v-for="item in foods" :key="item.id">

                    <food-item :item="item">

                        <!-- SLOT: ACTION BUTTONS -->
                        <template slot="action-buttons">
                            <div class="flex flex-wrap">

                                <!-- PRIMARY BUTTON: ADD TO WISH LIST -->
                                <div
                                        class="item-view-primary-action-btn p-3 flex flex-grow items-center justify-center cursor-pointer"
                                        @click="$router.push('/food/' + item.id);">
                                    <feather-icon icon="ArrowUpIcon" svgClasses="h-4 w-4" />


                                    <span class="text-sm font-semibold ml-2">Odpri</span>
                                </div>

                            </div>
                        </template>
                    </food-item>

                </div>
            </div>
        </template>


        <vs-popup title="Dodaj podkategorijo" :active.sync="addCategoryPromptActive">
            <vs-checkbox v-model="newCategoryAdditionChangePossible">Dovoljena zamenjava dodatkov</vs-checkbox>
            <p class="mt-6">Ime</p>
            <vs-input v-model="newCategoryName" style="width: 100%"></vs-input>

            <div class="vx-row mt-6">
                <div class="vx-col w-1/3"><h5>Odprto</h5></div>
                <div class="vx-col w-1/3"><h5>Od</h5></div>
                <div class="vx-col w-1/3"><h5>Do</h5></div>
            </div>
            <div class="vx-row mt-6">
                <div class="vx-col w-1/3 mt-3"><vs-checkbox v-model="workTimes[0].open">Ponedeljek</vs-checkbox></div>
                <div class="vx-col w-1/3"><flat-pickr :disabled="!workTimes[0].open" class="w-full" :config="configDateTimePicker" v-model="workTimes[0].start_time"/></div>
                <div class="vx-col w-1/3"><flat-pickr :disabled="!workTimes[0].open" class="w-full" :config="configDateTimePicker" v-model="workTimes[0].end_time"/></div>
            </div>
            <div class="vx-row mt-6">
                <div class="vx-col w-1/3 mt-3"><vs-checkbox v-model="workTimes[1].open">Torek</vs-checkbox></div>
                <div class="vx-col w-1/3"><flat-pickr :disabled="!workTimes[1].open" class="w-full" :config="configDateTimePicker" v-model="workTimes[1].start_time"/></div>
                <div class="vx-col w-1/3"><flat-pickr :disabled="!workTimes[1].open" class="w-full" :config="configDateTimePicker" v-model="workTimes[1].end_time"/></div>
            </div>
            <div class="vx-row mt-6">
                <div class="vx-col w-1/3 mt-3"><vs-checkbox v-model="workTimes[2].open">Sreda</vs-checkbox></div>
                <div class="vx-col w-1/3"><flat-pickr :disabled="!workTimes[2].open" class="w-full" :config="configDateTimePicker" v-model="workTimes[2].start_time"/></div>
                <div class="vx-col w-1/3"><flat-pickr :disabled="!workTimes[2].open" class="w-full" :config="configDateTimePicker" v-model="workTimes[2].end_time"/></div>
            </div>
            <div class="vx-row mt-6">
                <div class="vx-col w-1/3 mt-3"><vs-checkbox v-model="workTimes[3].open">Četrtek</vs-checkbox></div>
                <div class="vx-col w-1/3"><flat-pickr :disabled="!workTimes[3].open" class="w-full" :config="configDateTimePicker" v-model="workTimes[3].start_time"/></div>
                <div class="vx-col w-1/3"><flat-pickr :disabled="!workTimes[3].open" class="w-full" :config="configDateTimePicker" v-model="workTimes[3].end_time"/></div>
            </div>
            <div class="vx-row mt-6">
                <div class="vx-col w-1/3 mt-3"><vs-checkbox v-model="workTimes[4].open">Petek</vs-checkbox></div>
                <div class="vx-col w-1/3"><flat-pickr :disabled="!workTimes[4].open" class="w-full" :config="configDateTimePicker" v-model="workTimes[4].start_time"/></div>
                <div class="vx-col w-1/3"><flat-pickr :disabled="!workTimes[4].open" class="w-full" :config="configDateTimePicker" v-model="workTimes[4].end_time"/></div>
            </div>
            <div class="vx-row mt-6">
                <div class="vx-col w-1/3 mt-3"><vs-checkbox v-model="workTimes[5].open">Sobota</vs-checkbox></div>
                <div class="vx-col w-1/3"><flat-pickr :disabled="!workTimes[5].open" class="w-full" :config="configDateTimePicker" v-model="workTimes[5].start_time"/></div>
                <div class="vx-col w-1/3"><flat-pickr :disabled="!workTimes[5].open" class="w-full" :config="configDateTimePicker" v-model="workTimes[5].end_time"/></div>
            </div>
            <div class="vx-row mt-6">
                <div class="vx-col w-1/3 mt-3"><vs-checkbox v-model="workTimes[6].open">Nedelja</vs-checkbox></div>
                <div class="vx-col w-1/3"><flat-pickr :disabled="!workTimes[6].open" class="w-full" :config="configDateTimePicker" v-model="workTimes[6].start_time"/></div>
                <div class="vx-col w-1/3"><flat-pickr :disabled="!workTimes[6].open" class="w-full" :config="configDateTimePicker" v-model="workTimes[6].end_time"/></div>
            </div>

            <vs-divider/>

            <vs-button style="float: left" color="success" icon-pack="feather" icon="icon-plus" class="mt-6; mr-1" @click="addCategory">Dodaj</vs-button>

        </vs-popup>

        <vs-popup title="Uredi kategorijo" :active.sync="editCategoryPromptActive">
            <vs-checkbox v-model="editCategoryObject.addition_change_possible">Dovoljena zamenjava dodatkov</vs-checkbox>
            <p class="mt-6">Ime</p>
            <vs-input v-model="editCategoryObject.name" style="width: 100%"></vs-input>

            <div class="vx-row mt-6">
                <div class="vx-col w-1/3"><h5>Odprto</h5></div>
                <div class="vx-col w-1/3"><h5>Od</h5></div>
                <div class="vx-col w-1/3"><h5>Do</h5></div>
            </div>
            <div class="vx-row mt-6">
                <div class="vx-col w-1/3 mt-3"><vs-checkbox v-model="editCategoryObject.work_times[0].open">Ponedeljek</vs-checkbox></div>
                <div class="vx-col w-1/3"><flat-pickr :disabled="!editCategoryObject.work_times[0].open" class="w-full" :config="configDateTimePicker" v-model="editCategoryObject.work_times[0].start_time"/></div>
                <div class="vx-col w-1/3"><flat-pickr :disabled="!editCategoryObject.work_times[0].open" class="w-full" :config="configDateTimePicker" v-model="editCategoryObject.work_times[0].end_time"/></div>
            </div>
            <div class="vx-row mt-6">
                <div class="vx-col w-1/3 mt-3"><vs-checkbox v-model="editCategoryObject.work_times[1].open">Torek</vs-checkbox></div>
                <div class="vx-col w-1/3"><flat-pickr :disabled="!editCategoryObject.work_times[1].open" class="w-full" :config="configDateTimePicker" v-model="editCategoryObject.work_times[1].start_time"/></div>
                <div class="vx-col w-1/3"><flat-pickr :disabled="!editCategoryObject.work_times[1].open" class="w-full" :config="configDateTimePicker" v-model="editCategoryObject.work_times[1].end_time"/></div>
            </div>
            <div class="vx-row mt-6">
                <div class="vx-col w-1/3 mt-3"><vs-checkbox v-model="editCategoryObject.work_times[2].open">Sreda</vs-checkbox></div>
                <div class="vx-col w-1/3"><flat-pickr :disabled="!editCategoryObject.work_times[2].open" class="w-full" :config="configDateTimePicker" v-model="editCategoryObject.work_times[2].start_time"/></div>
                <div class="vx-col w-1/3"><flat-pickr :disabled="!editCategoryObject.work_times[2].open" class="w-full" :config="configDateTimePicker" v-model="editCategoryObject.work_times[2].end_time"/></div>
            </div>
            <div class="vx-row mt-6">
                <div class="vx-col w-1/3 mt-3"><vs-checkbox v-model="editCategoryObject.work_times[3].open">Četrtek</vs-checkbox></div>
                <div class="vx-col w-1/3"><flat-pickr :disabled="!editCategoryObject.work_times[3].open" class="w-full" :config="configDateTimePicker" v-model="editCategoryObject.work_times[3].start_time"/></div>
                <div class="vx-col w-1/3"><flat-pickr :disabled="!editCategoryObject.work_times[3].open" class="w-full" :config="configDateTimePicker" v-model="editCategoryObject.work_times[3].end_time"/></div>
            </div>
            <div class="vx-row mt-6">
                <div class="vx-col w-1/3 mt-3"><vs-checkbox v-model="editCategoryObject.work_times[4].open">Petek</vs-checkbox></div>
                <div class="vx-col w-1/3"><flat-pickr :disabled="!editCategoryObject.work_times[4].open" class="w-full" :config="configDateTimePicker" v-model="editCategoryObject.work_times[4].start_time"/></div>
                <div class="vx-col w-1/3"><flat-pickr :disabled="!editCategoryObject.work_times[4].open" class="w-full" :config="configDateTimePicker" v-model="editCategoryObject.work_times[4].end_time"/></div>
            </div>
            <div class="vx-row mt-6">
                <div class="vx-col w-1/3 mt-3"><vs-checkbox v-model="editCategoryObject.work_times[5].open">Sobota</vs-checkbox></div>
                <div class="vx-col w-1/3"><flat-pickr :disabled="!editCategoryObject.work_times[5].open" class="w-full" :config="configDateTimePicker" v-model="editCategoryObject.work_times[5].start_time"/></div>
                <div class="vx-col w-1/3"><flat-pickr :disabled="!editCategoryObject.work_times[5].open" class="w-full" :config="configDateTimePicker" v-model="editCategoryObject.work_times[5].end_time"/></div>
            </div>
            <div class="vx-row mt-6">
                <div class="vx-col w-1/3 mt-3"><vs-checkbox v-model="editCategoryObject.work_times[6].open">Nedelja</vs-checkbox></div>
                <div class="vx-col w-1/3"><flat-pickr :disabled="!editCategoryObject.work_times[6].open" class="w-full" :config="configDateTimePicker" v-model="editCategoryObject.work_times[6].start_time"/></div>
                <div class="vx-col w-1/3"><flat-pickr :disabled="!editCategoryObject.work_times[6].open" class="w-full" :config="configDateTimePicker" v-model="editCategoryObject.work_times[6].end_time"/></div>
            </div>

            <vs-divider/>

            <vs-button style="float: left" color="success" icon-pack="feather" icon="icon-plus" class="mt-6; mr-1" @click="editCategory">Save</vs-button>

        </vs-popup>

        <vs-popup title="Dodaj jed" :active.sync="addFoodPromptActive">
            <div>
                <p class="mt-6">Ime</p>
                <vs-input v-model="addFoodName" style="width: 100%"></vs-input>
                <p class="mt-6">Cena</p>
                <vs-input v-model="addFoodPrice" style="width: 100%"></vs-input>
                <vs-checkbox class="mt-6" v-model="addFoodAdditionChangePossible">Dovoljena zamenjava dodatkov</vs-checkbox>
                <p class="mt-6">Opis</p>
                <vs-textarea v-model="addFoodDescription" class="mt-3 w-full" />
                <vs-divider/>
                <vs-button color="success" class="mt-6; mr-1" @click="addFood">Dodaj</vs-button>
            </div>
        </vs-popup>
    </div>

</template>
<script>
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import AdditionsTable from "./AdditionsTable";
    import OptionsTable from "./OptionsTable";
    import FoodItem from "./FoodItem";

    export default {
        components: {
            FoodItem,
            OptionsTable,
            AdditionsTable,
            flatPickr
        },
        data(){
            return {
                categoryId: this.$route.params.id,
                category: '',
                items: [],

                foods: [],

                addCategoryPromptActive: false,

                addFoodPromptActive: false,
                addFoodName: '',
                addFoodPrice: '',
                addFoodAdditionChangePossible: true,
                addFoodDescription: '',

                configDateTimePicker: {
                    enableTime: true,
                    noCalendar: true,
                    time_24hr: true
                },

                workTimes: [{
                    open: true,
                    start_time: '09:00',
                    end_time: '21:00'
                },
                    {
                        open: true,
                        start_time: '09:00',
                        end_time: '21:00'
                    },
                    {
                        open: true,
                        start_time: '09:00',
                        end_time: '21:00'
                    },
                    {
                        open: true,
                        start_time: '09:00',
                        end_time: '21:00'
                    },
                    {
                        open: true,
                        start_time: '09:00',
                        end_time: '21:00'
                    },
                    {
                        open: true,
                        start_time: '09:00',
                        end_time: '21:00'
                    },
                    {
                        open: false,
                        start_time: '09:00',
                        end_time: '21:00'
                    },
                ],
                newCategoryName: '',
                newCategoryAdditionChangePossible: true,

                editCategoryTimes: {},
                editCategoryName: '',
                editCategoryAdditionChangePossible: false,
                editCategoryPromptActive: false,

                editCategoryObject: {},
            }
        },
        methods: {
            updateCategory() {
                const thisIns = this;
                this.$http.get('/api/listing/v1/categories/category/' + this.categoryId)
                    .then(function (response) {
                        thisIns.category = response.data;
                        thisIns.editCategoryObject = JSON.parse(JSON.stringify(thisIns.category));
                    }).catch(function (error) {
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            updateItems(){
                const thisIns = this;
                this.$vs.loading();
                thisIns.foods = [];
                this.$http.get('/api/listing/v1/categories/category/' + this.categoryId + "/food")
                    .then(function (response) {
                        thisIns.foods = response.data;
                        thisIns.$vs.loading.close();
                    }).catch(function (error) {
                    thisIns.$vs.loading.close();
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            removeCategory(){
                const thisIns = this;
                this.$http.delete('/api/management/v1/categories/category/' + this.categoryId)
                    .then(function () {
                        thisIns.$router.push("/");
                        thisIns.updateNavTree();
                    }).catch(function (error) {
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            addCategory(){

                const thisIns = this;
                this.$http.post('/api/management/v1/categories/category/' + this.$route.params.id + "/sub", {
                    name: this.newCategoryName,
                    work_times: this.workTimes,
                    addition_change_possible: this.newCategoryAdditionChangePossible
                }).then(function () {
                    thisIns.updateNavTree();
                    thisIns.addCategoryPromptActive = false;
                    thisIns.newCategoryName = '';
                }).catch(function (error) {
                    thisIns.addCategoryPromptActive = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            editCategory(){
                const thisIns = this;
                this.$http.put('/api/management/v1/categories/category/' + this.$route.params.id, this.editCategoryObject
                ).then(function () {
                    thisIns.updateNavTree();
                    thisIns.editCategoryPromptActive = false;
                }).catch(function (error) {
                    thisIns.editCategoryPromptActive = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            updateNavTree() {
                const thisIns = this;
                this.$http.get('/api/listing/v1/categories/navItems').then(function (response) {
                    thisIns.$store.dispatch('setNavTree', response.data);
                }).catch(function () {
                });
            },
            addFood(){

                const thisIns = this;
                this.$http.post('/api/management/v1/categories/category/' + this.$route.params.id + "/food", {
                    name: this.addFoodName,
                    description: this.addFoodDescription,
                    price: Number(this.addFoodPrice),
                    category_id: Number(this.$route.params.id),
                    addition_change_possible: this.addFoodAdditionChangePossible
                }).then(function (response) {
                    thisIns.addFoodPromptActive = false;
                    thisIns.$router.push("/food/" + response.data);
                }).catch(function (error) {
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
        },
        watch: {
            '$route.params.id'() {
                this.categoryId = this.$route.params.id;
                this.updateCategory();
                this.updateItems();
            }
        },
        created() {
            this.updateCategory();
            this.updateItems();
        }
    }
</script>
